import { useMemo, useState } from "react";

import Input from "../../ui/input/Input";
import Button from "../../ui/button/Button";
import Alert from "../../ui/alert/Alert";

import "./PasswordSetupForm.css";

function validatePassword(password) {
  const errors = [];

  if (password.length < 10) {
    errors.push("Minstens 10 tekens");
  }

  if (!/[A-Z]/.test(password)) {
    errors.push("Minstens 1 hoofdletter");
  }

  if (!/[a-z]/.test(password)) {
    errors.push("Minstens 1 kleine letter");
  }

  if (!/[0-9]/.test(password)) {
    errors.push("Minstens 1 cijfer");
  }

  if (!/[!@#$%^&*(),.?":{}|<>_\-+=/\\[\];'`~]/.test(password)) {
    errors.push("Minstens 1 speciaal teken");
  }

  return errors;
}

export default function PasswordSetupForm({
  onSubmit,
  isLoading,
  serverError,
}) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const passwordErrors = useMemo(() => {
    if (!password) return [];
    return validatePassword(password);
  }, [password]);

  const passwordsDoNotMatch =
    confirmPassword.length > 0 && password !== confirmPassword;

  const canSubmit =
    password.length > 0 &&
    confirmPassword.length > 0 &&
    passwordErrors.length === 0 &&
    !passwordsDoNotMatch &&
    !isLoading;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!canSubmit) return;

    onSubmit({
      password,
      confirmPassword,
    });
  };

  return (
    <form className="password-setup-form" onSubmit={handleSubmit}>
      {serverError && <Alert type="error">{serverError}</Alert>}

      <Input
        id="password"
        label="Nieuw wachtwoord"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Maak een sterk wachtwoord"
        autoComplete="new-password"
        disabled={isLoading}
      />

      <Input
        id="confirmPassword"
        label="Bevestig wachtwoord"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder="Herhaal je wachtwoord"
        autoComplete="new-password"
        disabled={isLoading}
        error={passwordsDoNotMatch ? "Wachtwoorden komen niet overeen." : ""}
      />

      <div className="password-rules">
        <p>Wachtwoord moet bevatten:</p>

        <ul>
          <li className={password.length >= 10 ? "is-valid" : ""}>
            Minstens 10 tekens
          </li>
          <li className={/[A-Z]/.test(password) ? "is-valid" : ""}>
            1 hoofdletter
          </li>
          <li className={/[a-z]/.test(password) ? "is-valid" : ""}>
            1 kleine letter
          </li>
          <li className={/[0-9]/.test(password) ? "is-valid" : ""}>1 cijfer</li>
          <li
            className={
              /[!@#$%^&*(),.?":{}|<>_\-+=/\\[\];'`~]/.test(password)
                ? "is-valid"
                : ""
            }
          >
            1 speciaal teken
          </li>
        </ul>
      </div>

      <Button type="submit" disabled={!canSubmit}>
        {isLoading ? "Bezig met instellen..." : "Wachtwoord instellen"}
      </Button>
    </form>
  );
}
